import { withSearch } from '@elastic/react-search-ui';
import MultiCheckboxFilter from '../../../components/filter/MultiCheckboxFilter';

function TeachingActivitiesSubjectFilter({
  addFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <MultiCheckboxFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="subject"
      filters={filters}
      formHint="Select all that apply."
      id="subject"
      label="Subject"
      orderByCount={true}
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, facets, filters }) => ({
  addFilter,
  removeFilter,
  facets,
  filters,
}))(TeachingActivitiesSubjectFilter);
